// extracted by mini-css-extract-plugin
export default {"AllUsers":"AllUsers_AllUsers__UKfJn"};